export default __webpack_public_path__ + "static/media/243.4ea17922.png";